import { ICoreContext } from '@msdyn365-commerce/core';
import { IAppSettingsInContext } from './app.settings.autogenerated';

export function getHideConversionInCategories(context: ICoreContext): number[] {
    const ctx = context as ICoreContext<IAppSettingsInContext>;

    // Parse the hideConversionsInCategories setting, which is expected to be a comma-separated string of category IDs
    const hideConversionInCategories = ctx.app.config?.hideConversionsInCategories
        ?.split(',').map(id => Number(id.trim())).filter(id => !isNaN(id)) || [];

    return hideConversionInCategories;
}

export function isAlternativeProductsEnabledForOUN(context: ICoreContext): boolean {
    const ctx = context as ICoreContext<IAppSettingsInContext>;

    // Get list of allowed OUNs for alternative products from config, which is expected to be a comma-separated string
    const allowedOUNsForAlternativeProducts = ctx.app.config?.alternativeProductsAllowedOUNs?.split(',').map(oun => oun.trim().toUpperCase()) || [];

    // Determine if alternative products should be shown based on feature flag and allowed OUNs
    const showAlternativeProducts = ctx.app.config?.enableAlternativeProductsFeature &&
        (allowedOUNsForAlternativeProducts.length === 0 || allowedOUNsForAlternativeProducts.includes(ctx.request.apiSettings.oun.toUpperCase()));

    return !!showAlternativeProducts;
}